export default __webpack_public_path__ + "static/media/elo.369c1192.svg";